/**
 * @file UsersViewPage.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la página de todos los usuarios
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-12-11
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import TitleComponent from "@/components/ui/TitleComponent";
import { useTranslations } from "next-intl";
import React from "react";
import UsersView from "./users-view";
import { UsersViewProps } from "../types";
const UsersViewPage: React.FC<UsersViewProps> = props => {
  const $ = _c(12);
  const usersTitle = useTranslations("Title.Users");
  let t0;
  if ($[0] !== usersTitle) {
    t0 = usersTitle("title");
    $[0] = usersTitle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== usersTitle) {
    t1 = usersTitle("description");
    $[2] = usersTitle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <TitleComponent title={t0} description={t1} />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props) {
    t3 = <UsersView {...props} />;
    $[7] = props;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default UsersViewPage;